var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLiveBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.76 62.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Naamloos_verloop_106-2);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        opacity: .85;\n      }\n\n      .cls-4 {\n        stroke: url(#Naamloos_verloop_238);\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n        opacity: .86;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.42px;\n      }\n\n      .cls-2 {\n        fill: url(#Naamloos_verloop_389);\n      }\n\n      .cls-3 {\n        fill: url(#Naamloos_verloop_106);\n      }\n\n      .cls-5 {\n        stroke: url(#Naamloos_verloop_238-6);\n      }\n\n      .cls-6 {\n        stroke: url(#Naamloos_verloop_238-3);\n      }\n\n      .cls-7 {\n        stroke: url(#Naamloos_verloop_238-2);\n      }\n\n      .cls-8 {\n        stroke: url(#Naamloos_verloop_238-4);\n      }\n\n      .cls-9 {\n        stroke: url(#Naamloos_verloop_238-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_106",
    "data-name": "Naamloos verloop 106",
    x1: 12.94,
    y1: 40.09,
    x2: 40.35,
    y2: 40.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e0e0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_106-2",
    "data-name": "Naamloos verloop 106",
    x1: 18.58,
    y1: 39.92,
    x2: 45.82,
    y2: 39.92,
    xlinkHref: "#Naamloos_verloop_106"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_389",
    "data-name": "Naamloos verloop 389",
    x1: 12.94,
    y1: 34.91,
    x2: 45.82,
    y2: 34.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9edee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238",
    "data-name": "Naamloos verloop 238",
    x1: 19.5,
    y1: 11.18,
    x2: 24.07,
    y2: 11.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ee7184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ef6a7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f25d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f54b64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fa3351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-2",
    "data-name": "Naamloos verloop 238",
    x1: 23.79,
    y1: 11.04,
    x2: 27.07,
    y2: 11.04,
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-3",
    "data-name": "Naamloos verloop 238",
    x1: 15.58,
    y1: 10.96,
    x2: 21.36,
    y2: 10.96,
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-4",
    "data-name": "Naamloos verloop 238",
    x1: 187.02,
    y1: 21.27,
    x2: 191.59,
    y2: 21.27,
    gradientTransform: "translate(226.4 32) rotate(-180)",
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-5",
    "data-name": "Naamloos verloop 238",
    x1: 191.31,
    y1: 21.12,
    x2: 194.6,
    y2: 21.12,
    gradientTransform: "translate(226.4 32) rotate(-180)",
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-6",
    "data-name": "Naamloos verloop 238",
    x1: 183.11,
    y1: 21.04,
    x2: 188.88,
    y2: 21.04,
    gradientTransform: "translate(226.4 32) rotate(-180)",
    xlinkHref: "#Naamloos_verloop_238"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14,62.14c-.31,0-.62-.14-.82-.4-.36-.45-.29-1.12.16-1.48l24.34-19.47-15.43-12.91-.03-.55c0-.35.17-.69.45-.9l10.02-8.16c.45-.37,1.12-.3,1.48.15.37.45.3,1.12-.15,1.48l-9.14,7.44,15.43,12.91.03.54c0,.35-.16.68-.43.9l-25.27,20.21c-.19.16-.43.23-.66.23ZM38.56,41.54s.05.05.08.07l-.08-.07ZM23.94,26.55l.09.07s-.06-.05-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.76,61.9c-.23,0-.46-.08-.66-.23l-25.52-20.38v-.58c0-.35.16-.67.45-.88l15.05-12.31-9.23-7.71c-.45-.37-.51-1.04-.13-1.48.37-.45,1.04-.51,1.49-.13l10.52,8.79.03.55c0,.36-.18.69-.47.9l-15.03,12.29,24.16,19.3c.45.36.53,1.03.17,1.48-.21.26-.51.4-.82.4ZM34.96,28.24s.05.05.08.07l-.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14,62.14c-.09,0-.19-.01-.28-.04-.56-.15-.89-.73-.74-1.3L27.07,9.55c.26-1.09,1.25-1.87,2.41-1.87,1.22,0,2.21.79,2.48,1.91l13.82,50.98c.15.56-.18,1.14-.74,1.29-.56.15-1.14-.18-1.29-.74L29.92,10.1c-.05-.2-.2-.32-.38-.32-.24,0-.39.12-.43.29l-14.1,51.3c-.13.47-.55.78-1.01.78Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.36,17.89c-1.93-1.68-3.16-4.16-3.16-6.93,0-2.53,1.03-4.83,2.69-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M26.37,14.81c-1.14-.89-1.87-2.28-1.87-3.84s.66-2.8,1.7-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M20.64,20.71c-2.67-2.4-4.34-5.87-4.34-9.74s1.68-7.35,4.36-9.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M35.52,4.03c1.93,1.68,3.16,4.16,3.16,6.93,0,2.53-1.03,4.83-2.69,6.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.51,7.11c1.14.89,1.87,2.28,1.87,3.84s-.66,2.8-1.7,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.24,1.22c2.67,2.4,4.34,5.87,4.34,9.74s-1.68,7.35-4.36,9.75"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiveBattery);
export default __webpack_public_path__ + "static/media/icon_live_battery.d944c01a519ab9b5fa01ca39f67b7e9d.svg";
export { ForwardRef as ReactComponent };